import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";

import MainPage from "./pages/dashboard/MainPage";

import MemberListPage from "./pages/dashboard/MemberListPage";
import AddMemberPage from "./pages/dashboard/AddMemberPage";
import MemberDetailPage from "./pages/dashboard/MemberDetailPage";

import LoanListPage from "./pages/dashboard/LoanListPage";
import LoanListFinishedPage from "./pages/dashboard/LoanListFinishedPage";
import CreateLoanPage from "./pages/dashboard/CreateLoanPage";
import LoanDetailPage from "./pages/dashboard/LoanDetailPage";
import LoanQueuePage from "./pages/dashboard/LoanQueuePage";



import { Toaster } from "react-hot-toast";


function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<MainPage />} />
          <Route path="main" element={<MainPage />} />
          <Route path="member" element={<MemberListPage />} />
          <Route path="member/:member_id" element={<MemberDetailPage />} />
          <Route path="member/create" element={<AddMemberPage />} />

          <Route path="loan" element={<LoanListPage />} />
          <Route path="loan-finished" element={<LoanListFinishedPage />} />
          <Route path="loan/:loan_id" element={<LoanDetailPage />} />
          <Route path="loan/create/:member_id" element={<CreateLoanPage />} />

          <Route path="waiting-list" element={<LoanQueuePage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
